import React from "react";
import logo from "/src/assets/img/png/logo_black_empty.png";
import "./AuthFormEdf.css";
import { env } from "/src/var/env";

function AuthFormEdf() {
    const handleSsoClick = () => {
        const apiUrl = env.REACT_APP_API_PATH || "http://localhost:8000";
        const baseUrl = apiUrl.replace("/api/v1", "");
        window.location.href = `${baseUrl}/login-sso-edf`;
    };

    return (
        <div className="edf-sso-container">
            <div className="edf-sso-header">
                <img src={logo} alt="Talkr Logo" className="edf-sso-logo" />
                <h1 className="edf-sso-title">Connexion EDF</h1>
                <p className="edf-sso-subtitle">Authentification sécurisée via GARDIAN-WebSSO</p>
            </div>

            <div className="edf-sso-content">
                <button className="edf-sso-button" onClick={handleSsoClick} type="button">
                    <span className="edf-sso-button-icon"></span>
                    <span className="edf-sso-button-text">Se connecter avec Gardian</span>
                </button>

                <p className="edf-sso-info">
                    Vous serez redirigé vers la page d'authentification sécurisée EDF (GARDIAN).
                </p>
            </div>
        </div>
    );
}

export default AuthFormEdf;
